module.exports = __webpack_public_path__ + "static/media/blockchain.0af8dc94.jpg";